"use strict";
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonsTripsTitleWidgetConfig = void 0;
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const getPersonsTripsTitleWidgetConfig = (
// FIXME: Type this when there is a few more widgets implemented
// FIXME: Add a common type for the getFormattedDate function if we keep it as option here (the actual implementation is frontend-only as it requires i18n locale)
options) => {
    const getContext = options.context || ((str) => str);
    return {
        type: 'text',
        align: 'left',
        text: (t, interview, _path) => {
            const person = odHelpers.getActivePerson({ interview });
            const journey = odHelpers.getActiveJourney({ interview });
            // FIXME Write a function somewhere to get the journey's or dateToString function, once we move to objects
            // FIXME2 Plan for a translation string that has a period (undated, dated, period)
            const journeyDates = journey && journey.startDate ? options.getFormattedDate(journey.startDate) : null;
            return t(['customSurvey:segments:Description', 'segments:Description'], {
                context: getContext(journeyDates === null ? 'undated' : undefined),
                nickname: person !== null && person.nickname ? person.nickname : '',
                journeyDates,
                count: person === null ? 1 : odHelpers.getCountOrSelfDeclared({ interview, person })
            });
        }
    };
};
exports.getPersonsTripsTitleWidgetConfig = getPersonsTripsTitleWidgetConfig;
//# sourceMappingURL=widgetPersonTripsTitle.js.map